import icon1 from '../assets/icon/pin/Pin/pinArancione.png';
import icon2 from '../assets/icon/pin/Pin/pinBlu.png';
import icon3 from '../assets/icon/pin/Pin/pinGiallo.png';
import icon4 from '../assets/icon/pin/Pin/pinRosa.png';
import icon5 from '../assets/icon/pin/Pin/pinTurchese.png';
import icon6 from '../assets/icon/pin/Pin/pinVerde.png';
import icon7 from '../assets/icon/pin/Pin/pinViola.png';
import icon8 from '../assets/icon/pin/Pin/PinRosso.png'

const icons = [
  { icon: icon1, label: "Potatura" },
  { icon: icon8, label: "Pulizia Strada" },
  { icon: icon2, label: "Abbattimento" },
  { icon: icon3, label: "Reti di recinzione" },
  { icon: icon4, label: "Sfalcio" },
  { icon: icon5, label: "Reti paramassi" },
  { icon: icon6, label: "Diserbo" },
  { icon: icon7, label: "Censimento arboreo" },
];

export default function LegendBox() {
  return (
    <div className="col-span-1 row-span-1 bg-primary rounded-2xl shadow p-6 flex flex-col gap-4 border-2 border-secondary h-full">
      <div>
        <h2 className="text-lg font-semibold text-white">Legenda Mappa</h2>
        <p className="text-sm text-smokey pt-1">
          Puoi trovare le attività <br/> in corso divise in:
        </p>
      </div>
      <ul className="flex flex-col gap-4 mt-6">
        {icons.map((item, index) => (
          <li key={index} className="flex items-center gap-3 text-sm text-white">
            <img src={item.icon} alt={`Icona ${index + 1}`} className="w-5" />
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
